<fieldset [formGroup]="skjema" data-testid="invitasjon-skjema">

  <mat-form-field class="navn">
    <mat-label>{{ 'Navn på nytt medlem...'|translate }}</mat-label>
    <input matInput formControlName="navn" name="navn" data-testid="navn-felt">
    @if (skjema.controls.navn.hasError('maxlength')) {
      <mat-error data-testid="maxlength">{{ skjema.controls.navn.errors | standardvalideringsfeil:'maxlength' }}
      </mat-error>
    }
    @if (duplikatMedlemFinnes) {
      <mat-hint>
        <i class="icon ion-android-warning"></i>
        {{ 'Det eksisterer allerede et medlem med samme navn'|translate }}
      </mat-hint>
    }
  </mat-form-field>

  <div class="epost-telefon">
    <mat-form-field class="epost">
      <mat-label>{{ 'E-postadresse'|translate }}</mat-label>
      <input matInput type="email" formControlName="epost" data-testid="epost-felt" #epostfelt>
      @if (skjema.controls.epost.hasError('eksistererMedlem')) {
        <mat-error data-testid="eksistererMedlem">{{ 'Det finnes allerede et medlem med denne epostadressen'|translate }}</mat-error>
      }
      @if (skjema.controls.epost.hasError('eksistererInvitasjon')) {
        <mat-error data-testid="eksistererMedlem">{{ 'Det finnes allerede en invitasjon med denne epostadressen'|translate }}</mat-error>
      }
      @if (skjema.controls.epost.hasError('eksistererInaktivt')) {
        <mat-error data-testid="eksistererMedlem">{{ 'Det finnes allerede et inaktivt medlem med denne epostadressen'|translate }}</mat-error>
      }
    </mat-form-field>

    <mat-form-field class="mobilnummer">
      <mat-label>{{ 'Mobiltelefonnummer'|translate }}</mat-label>
      <mobilnummer-felt formControlName="mobilnummer"/>
    </mat-form-field>
  </div>

  <div class="rolle-startdato">
    <mat-form-field class="rolle">
      <mat-label>{{ 'Rolle'|translate }}</mat-label>
      <mat-select formControlName="rolle" [compareWith]="erValgtRolle" data-testid="rolle-felt">
        <mat-option [value]="null">{{ 'Ingen rolle'|translate }}</mat-option>
        @for (rolle of roller | async; track rolle.id) {
          <mat-option [value]="rolle">{{ rolle.tittel }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    <mat-form-field class="startdato">
      <mat-label>{{ "Rollens startdato"|translate }}</mat-label>
      <input matInput [matDatepicker]="startdatoVelger" formControlName="rolleStartdato" class="e2e-startdato" data-testid="rolle-startdato-felt" #startdatofelt>
      <mat-datepicker-toggle matPrefix [for]="startdatoVelger"/>
      <mat-datepicker #startdatoVelger/>
      @if(skjema.controls.rolleStartdato.hasError('matDatepickerParse')){
        <mat-error data-testid="matDatepickerParse">{{ skjema.controls.rolleStartdato.errors | standardvalideringsfeil:'matDatepickerParse' }}</mat-error>
      }
    </mat-form-field>
  </div>


  <div class="tilganger">
    <span class="ramme-tittel">{{ 'Brukertilgang'|translate }}</span>
    <div class="tilgangsroller">
      @for (rolle of tilgjengeligeTilgangsroller; track rolle.rolleinfo.rolle) {
        <mat-checkbox [formControl]="rolle.kontroller">
          <div class="tittel">{{ rolle.rolleinfo.tittel(enumOversettelser) }}</div>
          <div class="subtittel">{{ rolle.rolleinfo.subtittel(enumOversettelser) }}</div>
        </mat-checkbox>
      }
    </div>
  </div>

</fieldset>
